import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { CompanyService } from '../../../services/company.service';
import { EmployeeService } from '../../../services/employee.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { VacationService } from '../../services/vacation.service';
import { SolicitudeService } from '../../../solicitude/services/solicitude.service';
import { forkJoin } from 'rxjs';
import { TypeVacationService } from '../../../services/type-vacation.service';
import { StateSolicitudesService } from '../../../services/state-solicitudes.service';
import { extractFileName, getDayLabel } from '../../../utils/helpers';

@Component({
  selector: 'app-vacation-detail-modal',
  templateUrl: './vacation-detail-modal.component.html',
  styleUrls: ['./vacation-detail-modal.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
})
export class VacationDetailModalComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() dataToView: any | null = null;
  @Input() id: any | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() editComplete = new EventEmitter<void>();
  getDayLabel = getDayLabel;

  userData: any = null;
  constructor(
    private vacationService: VacationService,
    private solicitudeService: SolicitudeService,
    private companyService: CompanyService,
    private employeeService: EmployeeService,
    private typeVacationService: TypeVacationService,
    private stateSolicitudesService: StateSolicitudesService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  // Propiedades para los combos
  selectedEmpresa: IComboBase | null = null;
  selectedColaborador: IComboBase | null = null;
  selectedOptionKey: number | null = null;
  selectedVacationType: any;
  selectedstatusSolicitude: any;

  previousStatusKey: string | null = null;

  isLoading: boolean = false;
  detailSolicitudId: number = 0;

  startDate: Date | null = null;
  endDate: Date | null = null;
  minDate: Date | null = null;
  maxStartDate: Date | null = null;
  maxEndDate: Date | null = null;
  tooltipVisible: string | null = null;

  calculateAccumulatedDays: number = 10;

  filteredVacationTypes: IComboBase[] = [];
  totalDays: number = 0;

  transferableDays = Math.max(
    0,
    this.calculateAccumulatedDays - this.totalDays
  );

  selectedDates: Date[] = [];
  messageCollaborator = '';
  messageToCollaborator = '';

  filteredOptions: IComboBase[] = [];
  empresas: IComboBase[] = [];
  colaboradores: IComboBase[] = [];
  vacationTypes: IComboBase[] = [];
  statusSolicitude: IComboBase[] = [];
  downloadUrl: string | null = null;
  currentFile: File | null = null;
  typeVacationId: any;
  selectedFileName: string | null = null;
  documentGenerated: boolean = false;
  startDateEmployee: Date | null = null;
  accumulatedDays: number = 0;
  usedDaysLaw: number = 0;
  accumulatedBonusDays: number = 0;
  usedBonusDays: number = 0;

  companyId: string | null = null;
  employeeId: number | null = null;

  isDisabled: boolean = true;

  hasInteracted: { [key: string]: boolean } = {
    tipoVacacion: false,
    endDate: false,
    startDate: false,
  };

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }

    this.previousStatusKey = this.selectedstatusSolicitude?.key;

    this.resetForm();
    this.calculateTotalDays();

    this.typeVacationService.comboTypeVacation().subscribe({
      next: (data) => {
        this.vacationTypes = data;
      },

      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
      },
    });

    this.stateSolicitudesService.comboStateSolicitudes().subscribe({
      next: (data) => {
        this.statusSolicitude = data;
      },

      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
      },
    });

    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.empresas = data;
      },

      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
      },
    });
  }

  ngOnChanges(): void {
    this.isLoading = true;
    if (this.dataToView) {
      this.detailSolicitudId = this.dataToView.detailSolicitudId;

      this.solicitudeService
        .getDetailSolicitudeByDetailSolicitudeId(this.detailSolicitudId)
        .subscribe({
          next: (solicitude) => {
            const observables = {
              empresas: this.companyService.comboCompany(),
              colaboradores: this.employeeService.comboEmployee(
                solicitude.companyId
              ),
            };

            forkJoin(observables).subscribe({
              next: ({ empresas, colaboradores }) => {
                this.empresas = empresas;
                this.colaboradores = colaboradores;

                this.selectedEmpresa =
                  this.empresas.find(
                    (e) => String(e.key) === String(solicitude.companyId)
                  ) || null;

                this.selectedColaborador =
                  this.colaboradores.find(
                    (c) => String(c.key) === String(solicitude.employeeId)
                  ) || null;

                this.startDate = solicitude.breakStartDate
                  ? this.parseCustomDate(solicitude.breakStartDate)
                  : null;

                this.endDate = solicitude.breakEndDate
                  ? this.parseCustomDate(solicitude.breakEndDate)
                  : null;

                this.syncSelectedDates();

                this.selectedVacationType =
                  this.vacationTypes.find(
                    (e) => String(e.key) === String(solicitude.typeVacationId)
                  ) || null;

                this.selectedOptionKey = this.selectedVacationType.key!;

                this.messageCollaborator = solicitude.detailMessageCollaborator
                  ? solicitude.detailMessageCollaborator
                  : '';

                this.messageToCollaborator = solicitude.detailMessageAdmin
                  ? solicitude.detailMessageAdmin
                  : '';

                this.typeVacationId = solicitude.typeVacationId;
                this.selectedstatusSolicitude =
                  this.statusSolicitude.find(
                    (e) =>
                      String(e.key) === String(solicitude.stateSolicitudeId)
                  ) || null;

                if (solicitude.solicitudeUrl) {
                  this.documentGenerated = true;
                  this.downloadUrl = solicitude.solicitudeUrl;
                  this.selectedFileName = extractFileName(
                    solicitude.solicitudeUrl
                  );
                }

                this.accumulatedDays = solicitude.accumulatedDays;
                this.accumulatedBonusDays = solicitude.accumulatedBonusDays;
                this.usedBonusDays = solicitude.usedBonusDays;
                this.usedDaysLaw = solicitude.usedDays;
                this.isLoading = false;
                // this.validateForm();
                this.calculateTotalDays();
                this.cdr.detectChanges();
              },
              error: (err) => {
                this.isLoading = false;
                console.error('Error al cargar los datos necesarios:', err);
              },
            });
          },
          error: (err) => {
            this.isLoading = false;
            console.error(
              'Error al obtener los detalles de la solicitud: ',
              err
            );
          },
        });
    }
  }

  parseCustomDate(dateString: string): Date {
    const [day, month, year] = dateString.split('/').map(Number);
    const fullYear = year < 100 ? 2000 + year : year;
    return new Date(fullYear, month - 1, day);
  }

  // Método para filtrar opciones
  filterOptions(event: any, type: string) {
    const query = event.query.toLowerCase();
    let options: IComboBase[] = [];
    switch (type) {
      case 'empresa':
        options = this.empresas;
        break;
      case 'colaborador':
        options = this.colaboradores;
        break;
      case 'status':
        options = this.statusSolicitude;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.filteredOptions = options.filter((option) =>
      option.text.toLowerCase().includes(query)
    );
  }

  // Manejar selección
  onSelect(event: any, type: string) {
    this.hasInteracted[type] = true;

    switch (type) {
      case 'empresa':
        this.selectedEmpresa = event.value ?? null;
        this.companyId = this.selectedEmpresa?.key!;
        this.selectedColaborador = null;

        if (this.companyId) {
          this.employeeService.comboEmployee(this.companyId).subscribe({
            next: (data) => {
              this.colaboradores = data;
            },
            error: (err) => {
              console.error('Error al obtener la lista de colaboradores:', err);
            },
          });
        }

        break;
      case 'colaborador':
        this.selectedColaborador = event.value ?? null;
        this.employeeId = Number(this.selectedColaborador?.key!);
        if (this.employeeId) {
          this.employeeService.getEmployeeById(this.employeeId).subscribe({
            next: (data) => {
              this.accumulatedDays = data.accumulatedDays;
              const [day, month, year] = data.startDate.split('/');
              this.startDateEmployee = new Date(`${year}-${month}-${day}`);
              this.filterVacationTypesBasedOnSeniority();
            },
            error: (err) => {
              console.error('Error al obtener la lista de colaboradores:', err);
            },
          });
        }

        break;
      case 'tipoVacacion':
        this.selectedVacationType = event.value ?? null;
        this.selectedOptionKey = this.selectedVacationType?.key || null;
        break;
      case 'status':
        this.selectedstatusSolicitude = event.value ?? null;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
  }

  filterVacationTypesBasedOnSeniority(): void {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    if (
      this.startDateEmployee &&
      this.startDateEmployee.getTime() <= oneYearAgo.getTime()
    ) {
      this.filteredVacationTypes = this.vacationTypes;
    } else {
      this.filteredVacationTypes = this.vacationTypes.filter(
        (type) => type.key == '1' || type.key == '4'
      );
    }
  }

  calculateTotalDays(): void {
    if (this.startDate && this.endDate) {
      const start = this.startDate;
      const end = this.endDate;

      const diffInDays =
        (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24) + 1;

      this.totalDays = diffInDays > 0 ? Math.round(diffInDays) : 0;
    } else {
      this.totalDays = 0;
    }
  }

  onCancel() {
    this.resetForm();
    this.closeDialog();
  }

  // Limpiar los campos del modal
  resetForm() {
    this.selectedEmpresa = null;
    this.selectedColaborador = null;
    this.selectedVacationType = null;
    this.startDate = null;
    this.endDate = null;
    this.messageCollaborator = '';
    this.messageToCollaborator = '';
    this.selectedDates = [];
    this.documentGenerated = false;
    this.downloadUrl = null;
    this.currentFile = null;
    this.selectedFileName = null;
    this.totalDays = 0;
    this.accumulatedBonusDays = 0;
    this.accumulatedDays = 0;
    this.usedDaysLaw = 0;
    this.usedBonusDays = 0;

    this.hasInteracted = {
      empresa: false,
      colaborador: false,
      tipoVacacion: false,
      endDate: false,
      startDate: false,
    };

    // this.calculateTotalDays();
    // this.syncSelectedDates();
    // this.validateForm();
  }

  downloadFile() {
    if (!this.downloadUrl) return;

    const link = document.createElement('a');
    link.href = this.downloadUrl;
    link.target = '_blank';
    link.download = this.downloadUrl.split('/').pop() || 'documento.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'empresa':
        this.selectedEmpresa = null;
        break;
      case 'colaborador':
        this.selectedColaborador = null;
        break;
      case 'tipoVacacion':
        this.selectedVacationType = null;
        break;
      case 'status':
        this.selectedstatusSolicitude = null;
        break;
      case 'startDate':
        this.startDate = event;
        break;
      case 'endDate':
        this.endDate = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    // this.validateForm();
  }

  validateField(field: string) {
    this.hasInteracted[field] = true;
  }

  filterVacationTypes(event: any): void {
    const query = event.query.toLowerCase();
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    this.filteredVacationTypes = this.vacationTypes.filter(
      (option) =>
        option.text.toLowerCase().includes(query) &&
        (this.startDateEmployee &&
        this.startDateEmployee.getTime() <= oneYearAgo.getTime()
          ? true
          : option.key == '1' || option.key == '4')
    );
  }

  openTooltipModal(title: string, description: string) {
    this.dialogService.open(ModalInfoComponent, {
      closable: false,
      data: {
        title: title,
        description: description,
      },
    });
  }

  onStartDateChange(selectedStartDate: Date): void {
    if (selectedStartDate) {
      this.startDate = selectedStartDate;
      this.resetDocumentState();

      if (this.selectedVacationType?.key != '4') {
        this.maxEndDate = new Date(selectedStartDate);
        this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
      } else {
        this.maxEndDate = null;
      }

      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = null;
      }

      this.syncSelectedDates();
      this.calculateTotalDays();
    } else {
      this.maxEndDate = null;
    }
  }

  onEndDateChange(selectedEndDate: Date): void {
    if (selectedEndDate) {
      this.resetDocumentState();

      if (this.startDate && selectedEndDate < this.startDate) {
        this.endDate = null;
      } else {
        this.endDate = selectedEndDate;
      }

      this.syncSelectedDates();
      this.calculateTotalDays();
    }
  }

  onRangeSelect(): void {
    if (Array.isArray(this.selectedDates) && this.selectedDates.length === 2) {
      this.resetDocumentState();

      this.startDate = this.selectedDates[0];
      this.endDate = this.selectedDates[1];
      if (this.startDate) {
        if (String(this.selectedVacationType?.key) != '4') {
          this.maxEndDate = new Date(this.startDate);
          this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
        } else {
          this.maxEndDate = null;
        }
      } else {
        this.maxEndDate = null;
      }
    }
    this.calculateTotalDays();
  }

  resetDocumentState() {
    this.documentGenerated = false;
    this.downloadUrl = '';
    this.currentFile = null;
    this.selectedFileName = null;
  }

  syncSelectedDates(): void {
    if (this.startDate && this.endDate) {
      this.selectedDates = [this.startDate, this.endDate];
    } else {
      this.selectedDates = [];
    }
  }
}
